import Spinner from '~/components/LoadingIndicator/Spinner';

import { useEntryCondition } from '~/hooks';

import EntryErrorFallback from './EntryErrorFallback';

import styles from './Entry.module.scss';

/**
 * @description - 앱 최초 실행 시 보여지는 페이지
 */
const Entry = ({ isAppTypeChecked = true }: { isAppTypeChecked?: boolean }) => {
  const { entryError } = useEntryCondition({ isAppTypeChecked });

  if (entryError) {
    return <EntryErrorFallback error={entryError} />;
  }

  return (
    <div className={styles['entry-container']}>
      <Spinner />
    </div>
  );
};

export default Entry;
